/**
 * The event bus allows triggering events anywhere and listening to theses events at any place in the application.
 *
 * Examples
 * *************
 * import eventBus
 * import eventBus from '@/modules/eventBus'
 *
 * trigger a "start request" event
 * eventBus.$emit('request-start', method, url, data, headers, options)
 *
 * listen to the event "request-start" in order to start the progress bar animation
 * eventBus.$on('request-start', this.startProgress)
 *
 * Stop listening to request-start event with this particular callback
 * eventBus.$off('request-start', this.startProgress)
 */
import Vue from 'vue'
const eventBus = new Vue()
export default eventBus
